import Chip from '@mui/material/Chip';

interface LabelBadgeProps {
  label: string;
}

export default function LabelBadge({ label }: LabelBadgeProps) {
  return (
    <Chip
      label={label}
      size="small"
      sx={(theme) => ({
        bgcolor: theme.brandV2.colors.treadGray8,
        border: `1px solid ${theme.brandV2.colors.treadGray7}`,
        borderRadius: '4px',
        color: theme.brandV2.colors.treadBlack,
        fontSize: '12px',
        fontWeight: 600,
      })}
    />
  );
}
